import { SystemActions } from 'store/actions/system';

const navHistoryMaxSize = 10;

export default {
  appBusy: (state = false, action) => (
    action.type === SystemActions.SET_APP_BUSY ? action.payload : state
  ),
  message: (state = null, action) => (
    action.type === SystemActions.SET_MESSAGE ? action.payload : state
  ),
  navHistory: (state = [], action) => {
    switch (action.type) {
      case SystemActions.NAV_HISTORY_ADD:
        state.unshift(action.payload);
        return state.slice(0, Math.min(state.length, navHistoryMaxSize));

      default:
        return state;
    }
  },

};
